function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import classNames from 'classnames';
import gettext from 'js-utils/gettext';
import Icon from '../../icon/Icon';
import { TABBABLE_INDEX } from '../../hotKeys/constants';
import ChevronUpChunkySvg from '../../iconography/icons/ChevronUpChunky';
import ChevronDownChunkySvg from '../../iconography/icons/ChevronDownChunky';

var DropLink =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(DropLink, _React$PureComponent);

  function DropLink() {
    _classCallCheck(this, DropLink);

    return _possibleConstructorReturn(this, _getPrototypeOf(DropLink).apply(this, arguments));
  }

  _createClass(DropLink, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props = this.props,
          tabIndex = _this$props.tabIndex,
          shouldFocusDropLink = _this$props.shouldFocusDropLink;
      return tabIndex === TABBABLE_INDEX && shouldFocusDropLink ? this._focus() : this._blur();
    }
  }, {
    key: "_getRef",
    value: function _getRef(ref) {
      this._link = ref;
      return this._link;
    }
  }, {
    key: "_blur",
    value: function _blur() {
      this._link.blur();
    }
  }, {
    key: "_focus",
    value: function _focus() {
      this._link.focus();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          children = _this$props2.children,
          fallbackUrl = _this$props2.fallbackUrl,
          dropUp = _this$props2.dropUp,
          onClick = _this$props2.onClick,
          tabIndex = _this$props2.tabIndex,
          hideDropIconWhenNarrow = _this$props2.hideDropIconWhenNarrow;
      var iconType = dropUp ? React.createElement(ChevronUpChunkySvg, null) : React.createElement(ChevronDownChunkySvg, null);
      var iconClassName = classNames('eds-dropdown-menu__icon', {
        'eds-dropdown-menu__icon--narrow-breakpoints': hideDropIconWhenNarrow
      });
      return React.createElement("a", {
        className: "eds-dropdown-menu__link ignore-react-onclickoutside",
        href: fallbackUrl,
        onClick: onClick,
        "data-spec": "dropdown-menu-link",
        role: "menuitem",
        ref: this._getRef.bind(this),
        onMouseEnter: this._focus.bind(this),
        onMouseLeave: this._blur.bind(this),
        tabIndex: tabIndex,
        "aria-label": gettext('Menu dropdown link')
      }, React.createElement("div", {
        className: "eds-dropdown-menu__contents",
        "data-spec": "dropdown-menu-contents"
      }, children), React.createElement("span", {
        className: iconClassName
      }, React.createElement(Icon, {
        type: iconType,
        color: "grey-400",
        isBlockLevel: true
      })));
    }
  }]);

  return DropLink;
}(React.PureComponent);

export { DropLink as default };